import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserNetworkType } from 'user/model/user-network.type';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface SynchronizeUserNetworkSelectedCalendarsParams {
	readonly networkType: UserNetworkType;
	readonly selectedCalendarsId: string[];
}

@Injectable({ providedIn: 'root' })
export class SynchronizeUserNetworkSelectedCalendarsApiMutation extends ApiMutation<
	void,
	SynchronizeUserNetworkSelectedCalendarsParams
> {
	client = 'iam';
	document = gql`
		mutation SynchronizeUserNetworkSelectedCalendars(
			$networkType: UserNetworkType!
			$selectedCalendarsId: [String]
		) {
			synchronizeUserNetworkSelectedCalendars(
				networkType: $networkType
				selectedCalendarsId: $selectedCalendarsId
			)
		}
	`;
	method = 'synchronizeUserNetworkSelectedCalendars';
}
